import { createSlice } from '@reduxjs/toolkit';
import ApexCharts from 'apexcharts'

const initialState = {
    cpu: {
        data: [],
        totalPercent: 0
    },
    memory: {
        data: [],
        used: 0,
        total: 0
    }
};

// ==============================|| SLICE - Files ||============================== //

const monitoringSlice = createSlice({
    name: 'monitoring',
    initialState,
    reducers: {
        setReportData(state, action) {
            const { cpu, memory, time } = action.payload
            if (cpu.numberOfCore) {
                let resCpuReport = [];
                resCpuReport = Array(cpu.numberOfCore).fill(null).map((core, index) => {
                    return {
                        name: `Core ${index + 1}`,
                        data: []
                    }
                })
                let totalPercent = 0
                resCpuReport.forEach((core, index) => {
                    totalPercent += cpu.percentPerCore[index]
                    const cpuCurrentObject = { x: time, y: cpu.percentPerCore[index] }
                    if (state.cpu.data.length) {
                        const cpuTempData = [...state.cpu.data[index].data, cpuCurrentObject]
                        core.data = cpuTempData.slice(Math.max(cpuTempData.length - 31, 0))
                    }
                    else {
                        core.data = [cpuCurrentObject]
                    }

                });

                state.cpu.data = resCpuReport;
                state.cpu.totalPercent = (totalPercent / cpu.numberOfCore);
            }
            const memoryCurrentObject = { x: time, y: memory.used }
            const memoryTempData = [...state.memory.data, memoryCurrentObject]
            state.memory.data = memoryTempData.slice(Math.max(memoryTempData.length - 31, 0))
            state.memory.total = memory.total
            state.memory.used = memory.used
        }
    }
});

const { setReportData } = monitoringSlice.actions;

export { setReportData }

export default monitoringSlice.reducer;
